module.exports = __webpack_public_path__ + "static/media/navbar-icon.1e6ef866.svg";